import { createTheme } from "@mui/material/styles";

const primaryMain = "#3F5044";      // لون اللوجو الأساسي
const primaryLight = "#5E6F62";
const primaryDark = "#2C3A31";

const secondaryMain = "#D5D0B6";    // الخلفية البيج
const secondaryLight = "#E5E1CC";
const secondaryDark = "#BEB89D";

const theme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: primaryMain,
      light: primaryLight,
      dark: primaryDark,
      contrastText: "#ffffff",
    },

    secondary: {
      main: secondaryMain,
      light: secondaryLight,
      dark: secondaryDark,
      contrastText: primaryDark,
    },

    background: {
      default: "#F8F7F2",
      paper: "#FFFFFF",
    },

    text: {
      primary: "#2E2E2E",
      secondary: "#6B6B6B",
    },

    divider: "#E0E0E0",
  },

  typography: {
    fontFamily: `"Cairo", "Roboto", "Helvetica", "Arial", sans-serif`,

    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },

    button: {
      fontWeight: 700,
      textTransform: "none",
    },
  },

  shape: {
    borderRadius: 12,
  },

  shadows: [
    "none",
    "0px 2px 8px rgba(0,0,0,0.05)",
    "0px 4px 16px rgba(0,0,0,0.08)",
    ...Array(22).fill("0px 8px 24px rgba(0,0,0,0.08)"),
  ],

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: "10px 20px",
        },
        containedPrimary: {
          background: `linear-gradient(135deg, ${primaryMain} 0%, ${primaryDark} 100%)`,
          boxShadow: "0 6px 20px rgba(63, 80, 68, 0.3)",
          "&:hover": {
            background: `linear-gradient(135deg, ${primaryDark} 0%, ${primaryMain} 100%)`,
            boxShadow: "0 8px 24px rgba(63, 80, 68, 0.4)",
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid #ECECEC",
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 12,
          },
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: primaryMain,
          boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
        },
      },
    },
  },
});

export default theme;